import { createApi } from '@reduxjs/toolkit/query/react';

import { CMSStandardSlug } from '@/slices/cms/standards/cmsStandards.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

import { CmsStandardRequirementItem } from './cmsStandardRequirements.types';

interface CmsStandardRequirementsResponse {
  standardRequirements?: CmsStandardRequirementItem[];
}

const cmsStandardRequirementsApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/cms/standard-requirements',
  }),
  reducerPath: 'cmsStandardRequirements',
  tagTypes: ['CmsStandardRequirements'],
  endpoints: (build) => ({
    getStandardRequirements: build.query<
      CmsStandardRequirementItem[],
      { slug: CMSStandardSlug }
    >({
      query: ({ slug }) => ({
        url: `/${slug}`,
        method: 'GET',
      }),
      transformResponse: (response: CmsStandardRequirementsResponse) =>
        response.standardRequirements ?? [],
    }),
  }),
});

export default cmsStandardRequirementsApi;
